export default {
  brand: "AllChinaBuy Spreadsheet",
  brandShort: "ACB Spreadsheet",
  tagline: "AllChinaBuy Ressourcecenteret",
  independentNote: "Dette er en uafhængig informationsressource og er ikke det officielle AllChinaBuy-websted.",

  nav: {
    home: "Forside",
    spreadsheet: "Spreadsheet",
    categories: "Kategorier",
    guides: "Guides",
    shoppingGuide: "Købsguide",
    browseCategories: "Gennemse kategorier",
    faq: "FAQ",
  },

  hero: {
    eyebrow: "ALLCHINABUY RESSOURCECENTERET",
    title: "AllChinaBuy Spreadsheet — Opdag Bedre Fund, Sælgere & Købsguides",
    subtitle: "Udforsk organiserede AllChinaBuy spreadsheet-fund, produktkategorier, QC-ressourcer, sælgerinformation, forsendelsesguides og praktiske købstips — alt på ét sted.",
    ctaPrimary: "AllChinaBuy Spreadsheet",
    ctaSecondary: "Køb Nu",
    trust: "Uafhængig ressource • Opdaterede guides • Køberfokuseret information",
    searchPlaceholder: "Søg AllChinaBuy spreadsheet, sko, hættetrøjer, QC, forsendelse...",
  },

  cards: {
    findsTitle: "Organiserede Fund",
    findsDesc: "Gennemse kuraterede AllChinaBuy spreadsheet-ressourcer efter kategori og produkttype.",
    qcTitle: "QC-ressourcer",
    qcDesc: "Lær at forstå QC-fotos, produktdetaljer og sælgerinformation.",
    shippingTitle: "Forsendelsesguides",
    shippingDesc: "Forstå internationale forsendelsesmuligheder, omkostninger og almindelige overvejelser.",
    buyingTitle: "Købsguides",
    buyingDesc: "Følg praktiske guides designet til både begyndere og erfarne købere.",
  },

  preview: {
    title: "AllChinaBuy Spreadsheet-eksempel",
    subtitle: "Et hurtigt kig på, hvordan vores spreadsheet organiserer fund, QC-status og sælgerinformation.",
    colProduct: "Produkt",
    colCategory: "Kategori",
    colQc: "QC",
    colSeller: "Sælger",
    colStatus: "Status",
    updated: "Opdateret",
    fresh: "Ny",
    verified: "Verificeret info",
    sellerInfo: "Sælgerinfo",
  },

  categories: {
    title: "Gennemse Produktkategorier",
    subtitle: "Spring direkte til enhver kategori på hovedwebstedet, og udforsk organiserede AllChinaBuy spreadsheet-fund.",
    dropdownLabel: "Vælg en kategori",
    shoes: "Sko",
    hoodies: "Hættetrøjer/Sweatshirts",
    tshirts: "T-Shirts",
    jackets: "Jakker",
    pants: "Bukser/Shorts",
    headwear: "Hovedbeklædning",
    sets: "Sæt",
    underwear: "undertøj/underbukser",
    jersey: "Trøjer",
    accessories: "Tilbehør",
    bags: "Tasker",
    belts: "Bælter",
    perfumes: "Parfumer",
    other: "Andet",
  },

  content: {
    title: "Hvad er AllChinaBuy Spreadsheet?",
    p1: "AllChinaBuy spreadsheet er en struktureret ressource, der organiserer produktfund, sælgerinformation, kvalitetstjek-noter (QC) og forsendelsesdetaljer på ét sted. I stedet for at scrolle gennem spredte annoncer bruger købere det til at sammenligne muligheder side om side og træffe mere informerede valg, før de afgiver en ordre.",
    p2: "Et velorganiseret AllChinaBuy spreadsheet grupperer typisk produkter efter kategori — sko, hættetrøjer, t-shirts, jakker, tasker og tilbehør — og tilføjer derefter praktiske felter som QC-status, sælgerpåldelighed og seneste opdateringsdato. Denne struktur hjælper både førstegangskøbere og erfarne shoppere med at spotte kvalitetsvarer hurtigere.",
    p3: "Ud over produktopdagelse fungerer spreadsheetet som en købsguide. Det kan indeholde noter om, hvordan man læser QC-fotos, hvordan man vurderer sælgere, og hvad man skal være opmærksom på under international forsendelse. Kombineret med vores købsguides forvandler det en rå liste til et ægte beslutningsværktøj.",
    linkLabel: "Læs den komplette AllChinaBuy spreadsheet-guide",
  },

  articleEntry: {
    title: "Fremhævet Guide",
    subtitle: "Originale, dybdegående ressourcer skrevet omkring AllChinaBuy spreadsheet-emnet.",
    cardTitle: "AllChinaBuy Spreadsheet: Den Komplette Købsguide",
    cardDesc: "Lær at bruge AllChinaBuy spreadsheet, vurdere sælgere, læse QC-fotos og vælge produkter med tillid.",
    readMore: "Læs Guiden",
  },

  pillars: {
    title: "Udforsk vores købsguides",
    subtitle: "Originale, dybdegående ressourcer om anmeldelser, forsendelse, QC, sælgere, sikkerhed og mere — alle bygget omkring AllChinaBuy spreadsheetet.",
    readMore: "Læs mere",
    minRead: "min læsning",
  },

  faq: {
    title: "Ofte Stillede Spørgsmål",
    q1: "Er dette det officielle AllChinaBuy-websted?",
    a1: "Nej. Dette er en uafhængig informationsressource, der hjælper købere med at forstå og bruge AllChinaBuy spreadsheet-fund, QC-tips og forsendelsesguides. Det er ikke tilknyttet den officielle AllChinaBuy-platform.",
    q2: "Hvad kan jeg finde i AllChinaBuy spreadsheet?",
    a2: "Organiserede produktfund på tværs af kategorier som sko, hættetrøjer, t-shirts, jakker, tasker og tilbehør — hver med nyttige felter som QC-status, sælgerinformation og seneste opdateringsdato.",
    q3: "Hvordan fungerer kategorierne?",
    a3: "Hver kategoriknap og dropdownen tager dig direkte til den matchende sektion på hovedwebstedet, hvor du kan gennemse produkter i den kategori.",
    q4: "Hvor kan jeg faktisk købe disse produkter?",
    a4: "Alle produkter er tilgængelige på hovedwebstedet. Brug knapperne \"AllChinaBuy Spreadsheet\" eller \"Køb Nu\" for at fortsætte dertil.",
  },

  footer: {
    aboutTitle: "Om Dette Websted",
    aboutDesc: "Et uafhængigt AllChinaBuy spreadsheet- og køberressourcecenter. Vi hjælper dig med at finde produkter hurtigere og handle med bedre information.",
    exploreTitle: "Udforsk",
    disclaimer: "Dette er en uafhængig informationsressource og er ikke det officielle AllChinaBuy-websted, medmindre det udtrykkeligt angives.",
    rights: "Alle rettigheder forbeholdes.",
  },

  languages: {
    en: "English",
    fr: "Français",
    da: "Dansk",
    de: "Deutsch",
  },
};